module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.d7d5d458.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/PDFReport/fonts/OpenSans-Regular.ttf
// module id = 1170
// module chunks = 0